module.exports = __webpack_public_path__ + "img/phone.026b8403.svg";